const TRAILING_COUNTRY = /,\s*(united states of america|united states|usa|us)\s*$/i;

export const stripCountrySuffix = (address) => {
  if (!address) return address;
  return address.replace(TRAILING_COUNTRY, "").trim();
};

export default stripCountrySuffix;
